import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import { Container, Row, Col, CardDeck, Card } from "react-bootstrap"
import SignUpComponent from "../../components/sign-up"

const EventHackathon2026RecapPage = ({ location }) => {
  return (
    <Layout>
      <SEO
        location={location}
        image="/images/pocam-white-bg.png"
        title="Beyond Tropes, Tokenism and Talk 2026"
        description="On Mar 4th, 2026, we gathered together to once again meaningfully push the needle on diversity, equity and inclusion. The second Inclusion Hackathon jointly organized by the Account Planning Group of Canada (APG) and People of Colour in Advertising and Marketing (POCAM)"
      />
      <section className="bg-dark text-white py-4 py-lg-5">
        <Container>
          <Row>
            <Col md="8">
              <h1 className="display-4 mb-3">The 2nd APG x POCAM BIPOC Inclusion Hackathon</h1>
              <h2 className="mb-0">
                It's time to redefine Canadian marketing by redefining "Canadian" 
              </h2>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="py-4 py-lg-5">
        <Container>
          <Row>
            <Col md="10">
              <p className="lead">
                Presented By:
              </p>
            </Col>
          </Row>

          <Row className="justify-content-md-center">
            <Col md="3">
              <img className="px-3" style={{ width: "100%" }} src={'/images/beyond-tropes-tokenism-and-talk/APG-Canada-Logo-RGB.svg'} alt="AGP Canada logo"/>
            </Col>
            <Col md="3">
              <img className="px-3" style={{ width: "100%" }} src={'/images/beyond-tropes-tokenism-and-talk/pocam-logo-red.png'} alt="POCAM logo"/>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="py-4 py-lg-5">
        <Container>
          <Row>
            <Col md="10">
              <p>
                On Mar 4th, 2026, we gathered together to once again meaningfully push the needle on diversity, equity and inclusion.
              </p>
              <p>
                The second Inclusion Hackathon jointly organized by the Account Planning Group of Canada (APG) and People of Colour in Advertising and Marketing (POCAM) posed this challenged to cross-disciplinary teams: Who are Canadians today and how can we more authentically connect with them?
              </p>
              <p>
                Four teams were tasked with designing and presenting their response in front of a live audience and panel of judges. 
              </p>
            </Col>
          </Row>

          <Row>
            <Col md="12">
              <div className="mt-5 mb-5">
                <hr/>
              </div>
            </Col>
          </Row>

          <Row className="mb-4">
            <Col md="8">
              <h3 className="mb-4">Background</h3>
            </Col>
          </Row>

          <Row className="justify-content-md-center mb-4">
            <Col md="10">
              <img style={{ width: "100%" }} src={'/images/beyond-tropes-tokenism-and-talk-2026-recap/Screenshot-2026-03-06-at-1.19.58-PM.png'} alt="The Brief"/>
            </Col>
          </Row>

          <Row className="justify-content-md-center">
            <Col md="10">
              <img style={{ width: "100%" }} src={'/images/beyond-tropes-tokenism-and-talk-2026-recap/Screenshot-2026-03-06-at-1.20.22-PM.png'} alt="The Template"/>
            </Col>
          </Row>

          <Row>
            <Col md="12">
              <div className="mt-5 mb-5">
                <hr/>
              </div>
            </Col>
          </Row>

          <Row className="mb-4">
            <Col md="8">
              <h3 className="mb-4">The Presentations</h3>
            </Col>
          </Row>

          <Row className="mb-5 justify-content-md-center">
            <Col md="10">
              <img style={{ width: "100%" }} src={'/images/beyond-tropes-tokenism-and-talk-2026-recap/Screenshot-2026-03-05-at-7.46.28-AM.png'} alt="Redifining Canadian: Authentic Diversity in CPG Advertising"/>
            </Col>
            
            <Col md="10">
              <a
                className="btn btn-primary mt-3"
                rel="noreferrer"
                href="/images/beyond-tropes-tokenism-and-talk-2026-recap/2nd-Inclusion-Hackathon-CPG-Team-1-Deck_Final.pdf"
                target="_blank"
              >
                Download CPG Team #1 Deck
              </a>
            </Col>
          </Row>

          <Row className="mb-5 justify-content-md-center">
            <Col md="10">
              <img style={{ width: "100%" }} src={'/images/beyond-tropes-tokenism-and-talk-2026-recap/Screenshot-2026-03-05-at-7.48.57-AM.png'} alt="Team 'MWC'"/>
            </Col>
            
            <Col md="10">
              <a
                className="btn btn-primary mt-3"
                rel="noreferrer"
                href="/images/beyond-tropes-tokenism-and-talk-2026-recap/APG-POCAM-BIPOC-2026_Team-2.pptx.pdf"
                target="_blank"
              >
                Download CPG Team #2 Deck
              </a>
            </Col>
          </Row>

          <Row className="mb-5 justify-content-md-center">
            <Col md="10">
              <img style={{ width: "100%" }} src={'/images/beyond-tropes-tokenism-and-talk-2026-recap/Screenshot-2026-03-05-at-7.50.39-AM.png'} alt="The Inclusion Council: a fresh approcach to financial services"/>
            </Col>
            
            <Col md="10">
              <a
                className="btn btn-primary mt-3"
                rel="noreferrer"
                href="/images/beyond-tropes-tokenism-and-talk-2026-recap/POCAM-Hackathon_DollarsandSense_InclusionCouncil.pdf"
                target="_blank"
              >
                Download Financial Services Team Deck
              </a>
            </Col>
          </Row>

          <Row className="justify-content-md-center">
            <Col md="10">
              <img style={{ width: "100%" }} src={'/images/beyond-tropes-tokenism-and-talk-2026-recap/Screenshot-2026-03-05-at-7.51.59-AM.png'} alt="The Fix It"/>
            </Col>
            
            <Col md="10">
              <a
                className="btn btn-primary mt-3"
                rel="noreferrer"
                href="/images/beyond-tropes-tokenism-and-talk-2026-recap/Retail-Team-Hackathon-PPT.pdf"
                target="_blank"
              >
                Download Retail Team Deck
              </a>
            </Col>
          </Row>

          <Row>
            <Col md="12">
              <div className="mt-5 mb-5">
                <hr/>
              </div>
            </Col>
          </Row>

          <Row className="mb-4">
            <Col md="8">
              <h3 className="mb-4">The Research</h3>
            </Col>
          </Row>

          <Row className="mb-5 justify-content-md-center">
            <Col md="10">
              <img style={{ width: "100%" }} src={'/images/beyond-tropes-tokenism-and-talk-2026-recap/Screenshot-2026-03-05-at-7.54.01-AM.png'} alt="Beyond the Maple Leaf: The New Canadian Soul"/>
            </Col>
            
            <Col md="10">
              <a
                className="btn btn-primary mt-3"
                rel="noreferrer"
                href="/images/beyond-tropes-tokenism-and-talk-2026-recap/APG-Canadian-Pride-Deep-Dive-Summary-Deck-Feb-2026-FIN.pdf"
                target="_blank"
              >
                Download
              </a>
            </Col>
          </Row>

          <Row className="justify-content-md-center">
            <Col md="10">
              <img style={{ width: "100%" }} src={'/images/beyond-tropes-tokenism-and-talk-2026-recap/Screenshot-2026-03-05-at-7.54.28-AM.png'} alt="Seeing the Whole Picture - Lessons from Indigenous Research on Trust, Access, and Inclusion"/>
            </Col>
            
            <Col md="10">
              <a
                className="btn btn-primary mt-3"
                rel="noreferrer"
                href="/images/beyond-tropes-tokenism-and-talk-2026-recap/APG-Hackathon-Presentation-Anik-Karimjee-Final-2.pdf"
                target="_blank"
              >
                Download
              </a>
            </Col>
          </Row>

          <Row>
            <Col md="12">
              <div className="mt-5 mb-5">
                <hr/>
              </div>
            </Col>
          </Row>

          <Row className="mb-4">
            <Col md="8">
              <h3 className="mb-4">Press Coverage</h3>
            </Col>
          </Row>

          <Row className="justify-content-md-center mb-5">
            <Col md="4">
              <CardDeck>
                <Card>
                  <a href="https://strategyonline.ca/2026/03/05/bipoc-hackathon-2026/" rel="noreferrer" target="_blank">
                    <Card.Img src="/images/beyond-tropes-tokenism-and-talk-2026-recap/Screenshot-2026-03-06-at-7.28.07-AM.png" alt="BIPOC Hackathon challenges 'Canadian' tropes in marketing"/>
                  </a>
                </Card>
              </CardDeck>
            </Col>
          </Row>

          <Row className="justify-content-md-center">
            <Col md="8">
              <div class="embed-responsive embed-responsive-16by9 mb-3">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/fb6vSZSAfbM?si=-ygF3giWLbFkG7VZ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
              </div>
              
              <div>
                <p>Rivo (<a href="http://watchrivo.com" rel="noreferrer" target="_blank">http://watchrivo.com</a>) is a streaming platform for stories that explore migration, identity, and belonging—through diverse and BIPOC voices, giving underrepresented communities a space to be seen, heard, and celebrated. Watch Rivo on Roku, Apple TV, Fire TV, and Android TV.</p>
              </div>
            </Col>
          </Row>

          <Row>
            <Col md="12">
              <div className="mt-5 mb-5">
                <hr/>
              </div>
            </Col>
          </Row>

          <Row className="mb-4">
            <Col md="8">
              <h3 className="mb-4">The Photos</h3>
            </Col>
          </Row>

          <Row className="mb-5 justify-content-md-center">
            <Col md="10">
              <CardDeck className="mb-4">
                <Card>
                  <Card.Img src="/images/beyond-tropes-tokenism-and-talk-2026-recap/Screenshot-2026-03-05-at-1.40.03-PM.png" alt=""/>
                </Card>

                <Card>
                  <Card.Img src="/images/beyond-tropes-tokenism-and-talk-2026-recap/DSC08688-scaled.jpg" alt=""/>
                </Card>

                <Card>
                  <Card.Img src="/images/beyond-tropes-tokenism-and-talk-2026-recap/Screenshot-2026-03-05-at-1.42.41-PM.png" alt=""/>
                </Card>
              </CardDeck>

              <CardDeck className="mb-4">
                <Card>
                  <Card.Img src="/images/beyond-tropes-tokenism-and-talk-2026-recap/Screenshot-2026-03-06-at-7.00.24-AM.png" alt=""/>
                </Card>

                <Card>
                  <Card.Img src="/images/beyond-tropes-tokenism-and-talk-2026-recap/DSC08935-scaled.jpg" alt=""/>
                </Card>

                <Card>
                  <Card.Img src="/images/beyond-tropes-tokenism-and-talk-2026-recap/DSC08822-scaled.jpg" alt=""/>
                </Card>
              </CardDeck>

              <CardDeck className="mb-4">
                <Card>
                  <Card.Img src="/images/beyond-tropes-tokenism-and-talk-2026-recap/DSC08840-scaled.jpg" alt=""/>
                </Card>

                <Card>
                  <Card.Img src="/images/beyond-tropes-tokenism-and-talk-2026-recap/DSC08899-1-scaled.jpg" alt=""/>
                </Card>

                <Card>
                  <Card.Img src="/images/beyond-tropes-tokenism-and-talk-2026-recap/DSC09018-scaled.jpg" alt=""/>
                </Card>
              </CardDeck>

              <CardDeck className="mb-4">
                <Card>
                  <Card.Img src="/images/beyond-tropes-tokenism-and-talk-2026-recap/DSC09234-scaled.jpg" alt=""/>
                </Card>

                <Card>
                  <Card.Img src="/images/beyond-tropes-tokenism-and-talk-2026-recap/DSC09320.jpg" alt=""/>
                </Card>

                <Card>
                  <Card.Img src="/images/beyond-tropes-tokenism-and-talk-2026-recap/DSC09359-scaled.jpg" alt=""/>
                </Card>
              </CardDeck>

              <CardDeck className="mb-4">
                <Card>
                  <Card.Img src="/images/beyond-tropes-tokenism-and-talk-2026-recap/DSC09396-scaled.jpg" alt=""/>
                </Card>

                <Card>
                  <Card.Img src="/images/beyond-tropes-tokenism-and-talk-2026-recap/DSC09399-scaled.jpg" alt=""/>
                </Card>

                <Card>
                  <Card.Img src="/images/beyond-tropes-tokenism-and-talk-2026-recap/DSC09400-scaled.jpg" alt=""/>
                </Card>
              </CardDeck>

              <CardDeck className="mb-4">
                <Card>
                  <Card.Img src="/images/beyond-tropes-tokenism-and-talk-2026-recap/DSC09402-scaled.jpg" alt=""/>
                </Card>

                <Card>
                  <Card.Img src="/images/beyond-tropes-tokenism-and-talk-2026-recap/DSC09405-scaled.jpg" alt=""/>
                </Card>

                <Card>
                  <Card.Img src="/images/beyond-tropes-tokenism-and-talk-2026-recap/DSC09409-scaled.jpg" alt=""/>
                </Card>
              </CardDeck>

              <CardDeck className="mb-4">
                <Card>
                  <Card.Img src="/images/beyond-tropes-tokenism-and-talk-2026-recap/DSC08788-scaled.jpg" alt=""/>
                </Card>

                <Card>
                  <Card.Img src="/images/beyond-tropes-tokenism-and-talk-2026-recap/DSC08699-scaled.jpg" alt=""/>
                </Card>

                <Card>
                  <Card.Img src="/images/beyond-tropes-tokenism-and-talk-2026-recap/DSC08658-scaled.jpg" alt=""/>
                </Card>
              </CardDeck>
          
              <CardDeck>
                <Card>
                  <Card.Img src="/images/beyond-tropes-tokenism-and-talk-2026-recap/DSC08606-scaled.jpg" alt=""/>
                </Card>

                <Card>
                  <Card.Img src="/images/beyond-tropes-tokenism-and-talk-2026-recap/DSC08622-scaled.jpg" alt=""/>
                </Card>

                <Card>
                  <Card.Img src="/images/beyond-tropes-tokenism-and-talk-2026-recap/DSC08733-scaled.jpg" alt=""/>
                </Card>
              </CardDeck>
            </Col>
          </Row>
        </Container>
      </section>

      <SignUpComponent />
    </Layout>
  )
}

export default EventHackathon2026RecapPage